export const getProductPageStartAndEndIndex = (
  perPage: number,
  currentPage: number,
  currentPageProductCount: number,
) => {
  const previousPagesProductCount = currentPage > 1 ? perPage * (currentPage - 1) : 0;

  return {
    start: previousPagesProductCount + 1,
    end: previousPagesProductCount + currentPageProductCount,
  };
};
